var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yd-dialog-white-mask"},[_c('div',{staticClass:"yd-loading"},[_c('div',{staticClass:"yd-loading-icon"}),_c('div',{staticClass:"yd-loading-txt",domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }